import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import { getWcoXmlWebAnalytics, getLoadingStatus } from '../../redux/wcoxmlweb/selectors';
import { wcoxmlwebActions } from '../../redux/wcoxmlweb/actions';

export const useCompanyData = () => {
  const { companyId } = useParams();
  const dispatch = useDispatch();
  const companyData = useSelector(getWcoXmlWebAnalytics);
  const loading = useSelector(getLoadingStatus);

  useEffect(() => {
    if (!companyId) return;

    dispatch(wcoxmlwebActions.getWcoXmlWebDetails(companyId));
  }, [dispatch, companyId]);

  return { companyData, loading };
};
